import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EmptyState = ({ type = 'no-routes', onAction }) => {
  const states = {
    'no-routes': {
      icon: 'Bus',
      title: 'Yakınınızda Rota Bulunamadı',
      description: 'Konumunuza yakın aktif dolmuş rotası bulunmamaktadır. Lütfen farklı bir konumdan tekrar deneyin veya arama yapın.',
      actionLabel: 'Rota Ara',
      actionIcon: 'Search'
    },
    'no-search-results': {
      icon: 'SearchX',
      title: 'Sonuç Bulunamadı',
      description: 'Arama kriterlerinize uygun rota bulunamadı. Lütfen farklı anahtar kelimeler deneyin.',
      actionLabel: 'Aramayı Temizle',
      actionIcon: 'X'
    },
    'location-error': {
      icon: 'MapPinOff',
      title: 'Konum Alınamadı',
      description: 'Konumunuza erişilemiyor. Lütfen tarayıcı ayarlarınızdan konum iznini kontrol edin.',
      actionLabel: 'Tekrar Dene',
      actionIcon: 'RefreshCw'
    }
  };

  const state = states?.[type] || states?.['no-routes'];

  return (
    <div className="flex flex-col items-center justify-center py-12 md:py-16 lg:py-20 px-4">
      <div className="flex items-center justify-center w-20 h-20 md:w-24 md:h-24 bg-muted rounded-full mb-6">
        <Icon name={state?.icon} size={40} color="var(--color-muted-foreground)" />
      </div>
      <h3 className="text-xl md:text-2xl lg:text-3xl font-bold text-foreground text-center mb-3">
        {state?.title}
      </h3>
      <p className="text-sm md:text-base text-muted-foreground text-center max-w-md mb-6">
        {state?.description}
      </p>
      {onAction && (
        <Button
          variant="default"
          onClick={onAction}
          iconName={state?.actionIcon}
          iconPosition="left"
        >
          {state?.actionLabel}
        </Button>
      )}
    </div>
  );
};

export default EmptyState;